var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("v-treeview", {
        ref: "treeview",
        staticClass: "treeview-icon",
        attrs: {
          role: "list",
          activatable: "",
          active: [_vm.activeCategory],
          open: _vm.openNodes,
          items: _vm.navigationCategories,
          "item-key": "key",
        },
        on: {
          "update:open": [
            _vm.fixAccessibilityRoles,
            function ($event) {
              _vm.openNodes = $event
            },
          ],
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function ({ item, active }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "tree-item-label",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.setTreeCategory(item)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.getCategoryUrl(item) },
                        on: {
                          click: function ($event) {
                            if ($event.target !== $event.currentTarget)
                              return null
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.name) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.category,
          callback: function ($$v) {
            _vm.category = $$v
          },
          expression: "category",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "top-codes" }, [
      _c("a", { staticClass: "bold-black", attrs: { href: "/codes" } }, [
        _vm._v("Codes"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }